import { render, staticRenderFns } from "./Announcement.vue?vue&type=template&id=28d2ab54&scoped=true"
import script from "./Announcement.vue?vue&type=script&lang=ts"
export * from "./Announcement.vue?vue&type=script&lang=ts"
import style0 from "./Announcement.vue?vue&type=style&index=0&id=28d2ab54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d2ab54",
  null
  
)

export default component.exports